
                export default function (Component) {
                    Component.__source = "library/components/VabLogo/index.vue"
                }
            